// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout3_wrapper__eBtSw","user":"Layout3_user__1JQkN","mainUser":"Layout3_mainUser__2U4XQ","topRow":"Layout3_topRow__3Yraw","bottomRow":"Layout3_bottomRow__1sKHy"};